export const properties = {
    oktaRedirectUri: '/osar/msi',
    oktaRedirectUriImplict: '/osar/msi/implicit/callback',
    oktaRedirectUriConfirmation: '/erums/order/confirmation/implicit/callback',
    erumsRedirectCookieName: 'erums-from-uri',
    storeResolverZipcodeToShoppingEndPoint: '/abs/qapub/xapi/storeresolver/zipcodetoshopping',
    clientBannerHeader: 'banner',
    headerStoreId: '',
    headerFulfillment: 'instore',
    storeId: '',
    tooltips: {
        personalizedSavings: {
            title: 'FreshPass™ Savings',
            text: 'Total savings are calculated starting on 6/22/2022. If you subscribed to FreshPass<sup>®</sup> after this date, your total savings are calculated starting on your subscription date. Total savings calculation is based on discounts to grocery delivery fees and redemption of perks listed on the FreshPass<sup>®</sup> subscription page.'
        },
        estimatedTotal: {
            title: 'Estimated Total',
            text: '<b>You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup.</b>' +
                ' The estimated total includes applicable delivery fees but does not include coupons clipped, buy one get one deals, club card, ' +
                'Schedule & Save and promo code discounts, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, the cost of substituted items, ' +
                'or reductions from out of stock items removed from your order. The final amount shown on your receipt at the time of delivery or pickup will reflect these adjustments. ' +
                'A hold will be placed on your debit/ credit card for this estimated total and will reduce the amount available to spend from your account. ' +
                'Your bank may take up to 5 business days after delivery/pickup to release the hold and display your final charge.',
            textV1: '',
            warning: false
        },
        estimatedSubTotal: {
            title: 'Estimated SubTotal',
            text: '<b>You will pay the prices, fees, and other charges, and receive the promotions, offers, discounts, and savings applicable to your order on the date of scheduled delivery/pickup.</b>' +
                ' The estimated sub total does not include coupons clipped, buy one get one deals, club card, Schedule & Save and promo code discounts, ' +
                'delivery fees if applicable, certain applicable taxes, bottle/can deposit, bag/other fees unless otherwise noted, ' +
                'the cost of substituted items, or reductions from out of stock items removed from your order.',
            textV1: '',
            warning: false
        },
        oneTimePurchaseItems: {
            title: 'One-Time Purchase Items',
            text: '<b>Use "Add Items" to include one-time purchase items in an already scheduled delivery/pickup order. One-time purchase items will not be added to future Schedule & Save orders.',
            textV1: '',
            warning: false
        },
        deliveryFee: {
            title: 'What is a Delivery Fee?',
            text: '<div>' + ' <div class="verticalSpace-5"></div>' +
                'A delivery fee helps us operate our fleet of trucks that transports your order from our facilities to your address.' +
                '</div>',
            warning: false
        },
        udcInfo: {
            title: 'Unlimited Delivery Club',
            text: '<p class="mb-2">Save money when you signup for unlimited deliveries for one low fee!<p>' +
                '<br/>' +
                'Sign up for one of our Unlimited Delivery Club Service plans and we will waive the delivery fee on any order over $30 for the selected duration. You can choose a monthly plan for $14.99 or an annual plan for $99. (The annual plan averages out to just $8.25/month.)',
            warning: false
        },
        udcTerms: {
            title: 'Unlimited Delivery Club Terms',
            text: '<p class="mb-2">You agree to consent and authorize storage of your debit and/or credit card data'
                + 'and authorize charges to such card for subscription fees after the 30-day free trial and'
                + 'for subsequent auto-renewals until you cancel.'
                + '</p>',
            warning: false
        },
        udcTermsFreeTrial: {
            title: 'Unlimited Delivery Club Terms',
            text: 'I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for subscription fees after the 30-day free trial and for subsequent auto-renewals until I cancel.',
            warning: false
        },
        udcTermsNonFreeTrial: {
            title: 'Unlimited Delivery Club Terms',
            text: 'I consent to and authorize storage of my debit and/or credit card data and authorize charges to such card for current subscription fees and future auto-renewals until I cancel.',
            warning: false
        },
        estimatedTax: {
            title: 'Estimated Taxes & Fees',
            text: 'The Estimated Taxes and Fees shown include your delivery fee (if applicable), any applicable taxes, bottle/can deposits, and bag/other fees. Your final receipt may reflect adjustments to these taxes, deposits and fees due to changes in your order, including but not limited to the availability or expiration of promotions, offers, discounts, and savings, the final cost of items sold by weight, item substitutions, or out of stock items removed from your order.'
        }
    },
    bannerConfiguration: {
        tomthumb: {
            banner: 'Tom Thumb',
            loyaltyPgmName: 'Reward Card',
            promoDescription: 'Reward Card Price',
            estimatedSavings: 'Est. Reward Card Savings',
            adaEstimatedSavings: 'Estimated Reward Card Savings',
            logoUrls: {
                color: 'TomThumb_RGB.svg',
                white: 'TomThumb_W.svg'
            }
        },
        albertsons: {
            banner: 'Albertsons',
            loyaltyPgmName: 'On Sale',
            promoDescription: 'On Sale Now',
            estimatedSavings: 'Est. On Sale Savings',
            adaEstimatedSavings: 'Estimated On Sale Savings',
            logoUrls: {
                color: 'Albertsons_RGB.svg',
                white: 'Albertsons_W.svg'
            },
        },
        vons: {
            banner: 'Vons',
            loyaltyPgmName: 'Club Card',
            promoDescription: 'Club Card Price',
            estimatedSavings: 'Est. Club Card Savings',
            adaEstimatedSavings: 'Estimated Club Card Savings',
            logoUrls: {
                color: 'Vons_RGB.svg',
                white: 'Vons_W.svg'
            },
        },
        safeway: {
            banner: 'Safeway',
            loyaltyPgmName: 'Club Card',
            promoDescription: 'Club Card Price',
            estimatedSavings: 'Est. Club Card Savings',
            adaEstimatedSavings: 'Estimated Club Card Savings',
            logoUrls: {
                color: 'Safeway_RGB.svg',
                white: 'Safeway_W.svg'
            },
        },
        randalls: {
            banner: 'Randalls',
            loyaltyPgmName: 'Remarkable Card',
            promoDescription: 'Remarkable Card Price',
            estimatedSavings: 'Est. Remarkable Card Savings',
            adaEstimatedSavings: 'Estimated Remarkable Card Savings',
            logoUrls: {
                color: 'Randalls_RGB.svg',
                white: 'Randalls_W.svg'
            },
        },
        pavilions: {
            banner: 'Pavilions',
            loyaltyPgmName: 'Club Price',
            promoDescription: 'Club Price',
            estimatedSavings: 'Est. Club Price Savings',
            adaEstimatedSavings: 'Estimated Club Price Savings',
            logoUrls: {
                color: 'Pavilions_RGB.svg',
                white: 'Pavilions_W.svg'
            },
        },
        jewelosco: {
            banner: 'Jewel-Osco',
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            adaEstimatedSavings: 'Estimated Sale Price Savings',
            logoUrls: {
                color: 'JewelOsco_Vert_Oval_RGB.svg',
                white: 'JewelOsco_Vert_Oval_W.svg'
            }
        },
        carrsqc: {
            banner: 'Carrs',
            loyaltyPgmName: 'Club Card',
            promoDescription: 'Club Card Price',
            estimatedSavings: 'Est. Club Card Savings',
            adaEstimatedSavings: 'Estimated Club Card Savings',
            logoUrls: {
                color: 'Carrs_RGB.svg',
                white: 'Carrs_W.svg'
            },
        },
        acmemarkets: {
            banner: 'Acme',
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            logoUrls: {
                color: 'Acme_RGB.svg',
                white: 'Acme_W.svg'
            }
        },
        shaws: {
            banner: 'Shaws',
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            logoUrls: {
                color: 'Shaws_RGB.svg',
                white: 'Shaws_W.svg'
            }
        },
        starmarket: {
            banner: 'Star Market',
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            logoUrls: {
                color: 'StarMarket_RGB.svg',
                white: 'StarMarket_W.svg'
            }
        },
        kingsfoodmarkets: {
            banner: "Kings",
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            logoUrls: {
                color: 'Kingsfoodmarkets_RGB.svg',
                white: 'Kingsfoodmarkets_W.svg'
            }
        },
        balduccis: {
            banner: "Balduccis",
            loyaltyPgmName: 'Sale Price',
            promoDescription: 'Sale Price',
            estimatedSavings: 'Est. Sale Price Savings',
            logoUrls: {
                color: 'Balduccis_RGB.svg',
                white: 'Balduccis_W.svg'
            }
        },
    },
    PromoTypeDescription: {
        BOGO: 'Buy 1 Get 1 Free',
        B2G1: 'Buy Two Get 1 Free'
    },
    timer: {
        lastLoginAllowedTime: 45
    },
    summaryTexts: {
        sumamrySnapText: 'SNAP Eligible Item Total',
        sumamryNonSnapText: 'Non-SNAP Eligible Item Total'
    },
    bannerMapper: {
        safeway: 'SAFEWAY',
        vons: 'VONS',
        randalls: 'RANDALLS',
        tomthumb: 'TOMTHUMB',
        acmemarkets: 'ACMEMARKETS',
        carrsqc: 'CARRSQC',
        jewelosco: 'JEWELOSCO',
        albertsons: 'ALBERTSONS',
        starmarket: 'STARMARKET',
        shaws: 'SHAWS',
        pavilions: 'PAVILIONS',
        kingsfoodmarkets: 'KINGSFOODMARKETS',
        balduccis: 'BALDUCCIS'
    },
    bannerLogoMapper: {
        safeway: '/content/dam/logos/Safeway_RGB.svg',
        vons: '/content/dam/logos/Vons_RGB.svg',
        randalls: '/content/dam/safeway/images/logos/Randalls_RGB.svg',
        tomthumb: '/content/dam/safeway/images/logos/TomThumb_RGB.svg',
        acmemarkets: '/content/dam/logos/Acme_RGB.svg',
        carrsqc: '/content/dam/logos/Carrs_RGB.svg',
        jewelosco: '/content/dam/safeway/images/logos/JewelOsco_Vert_Oval_RGB.svg',
        albertsons: '/content/dam/safeway/images/logos/Albertsons_RGB.svg',
        starmarket: '/content/dam/logos/StarMarket_RGB.svg',
        shaws: '/content/dam/logos/Shaws_RGB.svg',
        pavilions: '/content/dam/logos/Pavilions_RGB.svg',
        kingsfoodmarkets: '/content/dam/logos/Kingsfoodmarkets_RGB.svg',
        balduccis: '/content/dam/logos/Balduccis_RGB.svg'
    },
    invalidReasonCode: "Cancellation reason is invalid.",
    cancelDuringBatchProcess: "Subscription is renewing and cannot be cancelled.",
    cancelWithinBufferTime: "Your plan is currently being renewed and cannot be cancelled at this time.",
    serverError: "Internal server error occured.",
    unknownError: "Unknown error. Please contact the support team for resolution.",
    subsPaymentError: "Your enrollment cannot be processed. Please update your payment method and try again.",
    subsDefaultError: "Sorry, we\'re having technical difficulties and working on fixing them, please check back later.",
    cardUnacceptedError: "Card cannot be accepted. Please confirm card details were entered correctly or continue with another form of payment",
    freshpassBenefits: {
        "freshpass_tile_item__854420891": {
            "fpImage": "ocsp-web-ui/dist/assets/images/greenBenefitsTruck.svg",
            "rteTitle": "<div style=\"text-align: left;\">Unlimited Free Delivery on orders over $30<\/div>\r\n",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "benefitsTruck"
        },
        "freshpass_tile_item__1519499692": {
            "fpImage": "ocsp-web-ui/dist/assets/images/monthlycredit.svg",
            "rteTitle": "$5 Monthly Credit for Annual Subscribers",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "$5 monthly credit for annual subscribers"
        },
        "freshpass_tile_item_": {
            "fpImage": "ocsp-web-ui/dist/assets/images/save20.svg",
            "rteTitle": "Save $20 Off Your First Online Order Over $75",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "save 20 image"
        },
        "freshpass_tile_item__797202485": {
            "fpImage": "ocsp-web-ui/dist/assets/images/2xpoints.svg",
            "rteTitle": "<div style=\"text-align: left;\">Earn 2X Reward Points on Our Exclusive Brands<\/div>\r\n",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "Earn 2X Reward Points on Our Exclusive Brands"
        },
        "freshpass_tile_item__566169671": {
            "fpImage": "ocsp-web-ui/dist/assets/images/organic.svg",
            "rteTitle": "Save 5% on O Organics<sup>®<\/sup> and Open Nature<sup>®<\/sup>",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "Save 5% on O Organics and Open Nature"
        },
        "freshpass_tile_item__1650940289": {
            "fpImage": "ocsp-web-ui/dist/assets/images/pet.svg",
            "rteTitle": "Save 5% on Signature Pet Care<sup>®<\/sup>",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "Save 5% on Signature Pet Care"
        },
        "freshpass_tile_item__1951713976": {
            "fpImage": "ocsp-web-ui/dist/assets/images/rewardsDontExpire.svg",
            "rteTitle": "Rewards Don't Expire",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "Rewards don't expire"
        },
        "freshpass_tile_item__1555375445": {
            "fpImage": "ocsp-web-ui/dist/assets/images/starbucksCupArt.svg",
            "rteTitle": "Monthly Exclusive Starbucks<sup>®<\/sup> Perks",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "starbucks cup"
        },
        "freshpass_tile_item__1944760550": {
            "fpImage": "ocsp-web-ui/dist/assets/images/vipPhoneLine.svg",
            "rteTitle": "VIP Phone Line",
            "rule": "static",
            "infoIcon": "false",
            "textIsRich": "true",
            "tileImageAltText": "vip phone line"
        },
    },
    benefits_DUG5: {
        acme:  {
            "freshpass_tile_item__1": {
                "fpImage": "ocsp-web-ui/dist/assets/images/5OffDUG.svg",
                "rteTitle": "5% off Drive Up & Go™ orders** Ends 8/15",
                "rule": "static",
                "infoIcon": "false",
                "textIsRich": "true",
                "tileImageAltText": "drive up and go image"
            },
        },
        jewelosco: {
            "freshpass_tile_item__2": {
                "fpImage": "ocsp-web-ui/dist/assets/images/5OffDUG.svg",
                "rteTitle": "5% off Drive Up & Go™ orders** Ends 6/15",
                "rule": "static",
                "infoIcon": "false",
                "textIsRich": "true",
                "tileImageAltText": "drive up and go image"
            },
        }
    },
    
    snackbar: {
        discountAndActive: {
            message:"We’re sorry, this promotion is only available for new FreshPass subscribers.",
            type:"error",
            show: true,
            closeOption:true,
            from:"discountCampaignAndActiveMembership",
            timer: 5000,
            closeOnClick: true,
            theme:"black",
            topVH: "12vh",
            leftVH: '80vw',
        }
    },
    featureFlags: {
      enableEmployeeDiscount: false,
      enableSnap: false,
      enablePartner: false
    },
    freshpassRestrictedZipcodes: ["86040"],
};
